module.exports = __webpack_public_path__ + "static/img/公司15.53245b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司15.jpg
// module id = jkhg
// module chunks = 1